import React from 'react';
import { size } from 'lodash';
import TooltipWrapper from '../TooltipWrapper';

function SelectFieldListItemTip({
    children,
    itemId = '',
    itemName = '',
    maxTextSize = 25,
    optClass = '',
    position = 'top-end',
  }) {
  const idSize = size(itemId);
  const nameSize = size(itemName);
  const tipDiv = (
    <div className="select-field-item-tooltip">
      <div className="select-field-item-id">{itemId}</div>
      <div>{itemName}</div>
    </div>
);

  return (
    idSize > maxTextSize || nameSize > maxTextSize
      ? (
        <TooltipWrapper
          hideHighlight
          position={position}
          tip={tipDiv}
        >
          <div
            className={optClass}
          >
            <>{children}</>
          </div>
        </TooltipWrapper>
)
      : <>{children}</>
  );
}

export default SelectFieldListItemTip;
